import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { getOrgTermsContent } from '../../../content/utils.js';
import { momentToDateString } from '../../../lib/utils.js';
import {
  createActivity,
  deleteActivity,
  selectActivity,
  updateActivity,
} from '../../../modules/activities.js';
import FormModal from '../../FormModal.jsx';
import ActivityForm from './ActivityForm.jsx';

const mapStateToProps = (state, ownProps) => {
  const activity = selectActivity(state, ownProps);
  return {
    activity: activity
      ? omit(activity, ['id', 'influencePosition', 'interestPosition'])
      : undefined,
  };
};

const mapDispatchToProps = {
  createActivity,
  deleteActivity,
  updateActivity,
};

function formatActivityValues(values) {
  return {
    ...values,
    startDate: momentToDateString(values.startDate),
    endDate: momentToDateString(values.endDate),
  };
}

ActivityFormModal.propTypes = {
  activityId: PropTypes.number,
  onHide: PropTypes.func.isRequired,
  projectId: PropTypes.number.isRequired,
  reloadProject: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

function ActivityFormModal({
  activity,
  activityId,
  createActivity,
  deleteActivity,
  onHide,
  projectId,
  reloadProject,
  show,
  updateActivity,
}) {
  const createResource = useCallback(
    (values) => createActivity(projectId, formatActivityValues(values)),
    [createActivity, projectId]
  );

  const deleteResource = useCallback(
    () => deleteActivity(activityId),
    [deleteActivity, activityId]
  );

  const updateResource = useCallback(
    (values) => updateActivity(activityId, formatActivityValues(values)),
    [activityId, updateActivity]
  );

  const validate = useCallback((values) => {
    const errors = {};
    if (!values.title) {
      errors.title = 'Title is required';
    }
    if (!values.startDate) {
      errors.startDate = 'Start Date is required';
    }
    if (!values.endDate) {
      errors.endDate = 'End Date is required';
    }
    return errors;
  }, []);

  return (
    <FormModal
      createResource={createResource}
      deleteResource={deleteResource}
      onDeleteSuccess={reloadProject}
      onHide={onHide}
      onSubmitSuccess={reloadProject}
      resource={activity}
      resourceName={getOrgTermsContent('activity')}
      show={show}
      updateResource={updateResource}
      validate={validate}
    >
      <ActivityForm />
    </FormModal>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityFormModal);
